package macha.sh.kotlin.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import kotlinx.browser.window
import kotlinx.coroutines.await
import macha.sh.kotlin.SiteModifiers
import macha.sh.kotlin.components.layouts.PageLayoutData
import macha.sh.kotlin.components.widgets.SimpleMarkdown
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.Div

private const val ABOUT_RESOURCE_PATH = "text-content/page-content/about/about.md"

@InitRoute
fun initAboutPage(ctx: InitRouteContext) {
    ctx.data.add(
        PageLayoutData(
            title = "About",
            description = "Background, technical interests, and working philosophy of Macha.",
            path = "/about",
            indexable = false,
            markdownPath = "/text-content/page-content/about/about.md",
        )
    )
}
@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun AboutPage() { AboutStructure.Content() }

object AboutStructure {
    private val Mods = SiteModifiers.About
    @Composable
    fun Content() = Column(modifier = Modifier.fillMaxWidth()) {
        var content by remember { mutableStateOf<String?>(null) }
        var error by remember { mutableStateOf<String?>(null) }
        LaunchedEffect(Unit) {
            try {
                val response = window.fetch(ABOUT_RESOURCE_PATH).await()
                if (response.ok) { content = response.text().await() ; error = null } 
                else { content = null ; error = "Could not load content (HTTP ${'$'}{response.status})." }
            } catch (t: Throwable) {
                error = "Error loading content: ${'$'}{t.message}"
                content = null
            }
        }
        Column(modifier = Mods.container()) {
            when {
                content == null && error == null -> {
                    Div { org.jetbrains.compose.web.dom.Text("Loading content…") }
                }
                error != null -> {
                    Div { org.jetbrains.compose.web.dom.Text(error!!) }
                }
                else -> {
                    // Render fetched markdown using a compact, local style
                    macha.sh.kotlin.components.widgets.MarkdownSection(text = content!!)
                }
            }
        }
    }
}
